import {OperatorModel} from '../models/operator.model';
import { Injectable } from "@angular/core";

@Injectable()
export class DummyOperators {


    public populateDummyOperators(): OperatorModel[] {
        const doNotQueue = new OperatorModel();
        const none = new OperatorModel();
        const dummyOpList = new Array<OperatorModel>();
        doNotQueue.cod = -1;
        doNotQueue.username = 'Do not Queue';
        none.cod = 0;
        none.username = 'None';
        // dummyOpList.push(doNotQueue);
        dummyOpList.push(none);

        return dummyOpList;
    }
}

